import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Layout from "./layout";
import SearchIcon from "@mui/icons-material/Search";
import TableSortLabel from "@mui/material/TableSortLabel";
import DownloadIcon from "@mui/icons-material/Download";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { jsPDF } from "jspdf";
import axios from "axios";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { DialogActions, DialogContentText } from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import "jspdf-autotable";
import "../App.css";
import CreateSale from "./CreateSale";
import addSaleIcon from "../images/addSale.png";
import editSaleIcon from "../images/editSale.png";
import returnSaleIcon from "../images/returnSale.png";
import Tooltip from "@mui/material/Tooltip";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import ReturnSale from "./ReturnSale";
import { CircularProgress } from "@mui/material";
import { useAcademicYear } from "./AcademicYearContext";
import { getInstituteConfig } from "../utility/instituteConfig";

export default function Sale() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [search, setSearch] = useState("");
  const [gradeName, setGradeName] = useState("");
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("sales_id");
  // const [academicYearId, setAcademicYearId] = useState(0);
  const [sectionName, setSectionName] = useState("");
  const [data, setData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [product, setProduct] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedSalesId, setSelectedSalesId] = useState(null);
  const [openComponent, setOpenComponent] = useState(false);
  const [studentId1, setStudentId1] = useState("");
  const [studentName, setStudentName] = useState("");
  const [selectedData, setSelectedData] = useState(null);
  const [dialogType, setDialogType] = useState(""); // Add this line
  const [paidStatusId, setPaidStatusId] = useState(null);
  const [issuedStatusId, setIssuedStatusId] = useState(null);
  const [refundedStatusId, setRefundedStatusId] = useState(null);
  const [saleStatus, setSaleStatus] = useState([]);
  const [userId, setUserId] = useState();
  const [totalStockQuantity, setTotalStockQuantity] = useState([]); // Initialize appropriately
  const [totalQuantity, setTotalQuantity] = useState([]); // Initialize appropriately
  const [totalProduct, setTotalProduct] = useState([]); // Initialize as needed
  const [deleteFlag, setDeleteFlag] = useState(false);
  const [deleteData, setDeleteData] = useState([]);
  const [statusName, setStatusName] = useState("");
  const [statusId, setStatusId] = useState(undefined);
  const [openComponentCreateSale, setOpenComponentCreateSale] = useState(false);
  const [openComponentRefundSale, setOpenComponentRefundSale] = useState(false);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false); // Loading state
  const [statusCreatedId, setStatusCreatedId] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessageForReturn, setDialogMessageForReturn] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  // Selecting a status no longer applies it immediately — statusId reflects
  // whatever's currently picked in the dropdown, but the fetch only uses
  // appliedStatusId, which is set (along with the search term) when Go is
  // clicked. That lets search text and status be combined into one filter
  // applied together in a single request.
  const [appliedStatusId, setAppliedStatusId] = useState(undefined);

  const instituteId = localStorage.getItem("instituteId");

  const handleClick = (row) => {
    if (row.description === "Issued" || row.description === "Partial Refund") {
      handleOpenComponentRefundSale(row); // Open refund sale component
    } else if (row.description === "Created" || row.description === "Paid") {
      setDialogMessageForReturn("Cannot return. Your products have not been issued yet.");
      setOpenDialog(true);
    } else if (row.description === "Refunded") {
      setDialogMessageForReturn("Your products are already refunded.");
      setOpenDialog(true);
    }
  };



  const navigate = useNavigate();

  const { academicYearId } = useAcademicYear();

  useEffect(() => {
    console.log("Received Academic Year ID:", academicYearId);
  }, [academicYearId]);

  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } }
        );

        if (response.status === 200) {
          setUserId(response.data.user.user_id);
          console.log("response", response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

  const getSaleStatus = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/getSalesStatus`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      console.log("Fetched data:", data);

      // Extract specific sale_status_id for descriptions "Paid" and "Issued"
      const paidStatus =
        data.find((item) => item.description === "Paid")?.sales_status_id ||
        null;
      const issuedStatus =
        data.find((item) => item.description === "Issued")?.sales_status_id ||
        null;
      const refundedStatus =
        data.find((item) => item.description === "Refunded")?.sales_status_id ||
        null;

      console.log("Paid Sale Status ID:", paidStatus);
      console.log("Issued Sale Status ID:", issuedStatus);

      // Set the complete data and the extracted IDs in state
      setSaleStatus(data);
      setPaidStatusId(paidStatus);
      setIssuedStatusId(issuedStatus);
      setRefundedStatusId(refundedStatus);
    } catch (error) {
      console.error("Error fetching sales status:", error);
    }
  };

  useEffect(() => {
    getSaleStatus();
  }, []);

  useEffect(() => {
    // Reset deleteData when the component mounts
    setDeleteData([]);
    getProduct(); // Fetch products after resetting state
  }, []);

  useEffect(() => {
    console.log("Current deleteData:", deleteData);
  }, [deleteData]);

  const handleOpenComponentCreateSale = () => {
    setOpenComponentCreateSale(true);
  };

  const handleOpenComponentRefundSale = (row) => {
    setStudentId1(row.student_id || "Unknown ID");
    setStudentName(`${row.first_name || ""} ${row.last_name || ""}`);
    setGradeName(row.grade_name);
    setSectionName(row.section_name);
    console.log("row.sales_id:", row.sales_id);
    console.log("row.first_name:", row.first_name);
    setSelectedSalesId(row.sales_id);
    setOpenComponentRefundSale(true);
  };
  const handleOpenComponent = (row) => {
    console.log("ro", row);
    setStatusCreatedId(row.sale_status_id);
    // Use setDeleteData correctly to maintain the array state
    setDeleteData((prevData) => {
      // Check if prevData is actually an array
      if (Array.isArray(prevData)) {
        return [...prevData, row]; // Append the new row
      }
      return [row]; // If prevData is not an array, start a new array
    });
    setDeleteFlag(true);
    setSelectedData(row);
    setStudentId1(row.student_id || "Unknown ID");
    setStudentName(`${row.first_name || ""} ${row.last_name || ""}`);
    setGradeName(row.grade_name);
    setSectionName(row.section_name);
    console.log("row.sales_id:", row.sales_id);
    console.log("row.first_name:", row.first_name);
    setSelectedSalesId(row.sales_id);
    setOpenComponent(true);
  };

  const handleCloseComponent = () => {
    setOpenComponent(false);
    setOpenComponentCreateSale(false);
    setOpenComponentRefundSale(false);
    setStudentId1("");
    setStudentName("");
    // A sale may have just been created/edited/refunded — refresh with
    // maintenance so any resulting stale/incomplete rows get cleaned up.
    getSales({ runMaintenance: true });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const openList = (salesId) => {
    setSelectedSalesId(salesId);
    console.log("salesId", salesId);

    // Fetch product data first
    getProduct(salesId);
    // Then open the dialog
    setOpen(true);
  };

  useEffect(() => {
    getProduct(selectedSalesId);
  }, [selectedSalesId]);

  const getProduct = async (salesId) => {
    console.log("res", salesId);
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/sales/getProduct",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            sales_id: salesId,
          }),
        }
      );

      // If the response status is 401, call signOut
      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Product API response:", data);

      setStatus(data[0].sales_status);

      console.log("status", data[0].sales_status);

      // Only update the product state after data is fetched
      if (data.length > 0) {
        setProduct(data);
      }
    } catch (error) {
      console.error("Error fetching refund data:", error);
    }
  };

  const handleCheckboxClick = (row) => {
    console.log("che", row);

    // Handle different statuses
    if (row.description === "Created") {
      setDialogMessage(
        `Product(s) cannot be issued because the payment for Indent ID ${row.sales_id} has not been completed.`
      );
      setDialogType("info");
      setDialogOpen(true);
      return;
    } else if (row.description === "Paid") {
      setDialogMessage(
        `Are you sure you want to update status for Indent ID ${row.sales_id} from "Paid" to "Issued"?`
      );
      setDialogType("confirmation");
    }

    // Store the sales ID for use later
    setSelectedSalesId(row.sales_id);

    console.log("Row Sales Id:", row.sales_id);
    console.log("Row Sales Details:", row.sales_details);

    // ✅ Check if sales_details exists before mapping
    if (!row.sales_details || row.sales_details.length === 0) {
      console.warn("⚠️ No sales details found for this row.");
      setTotalProduct([]);
      setTotalQuantity([]);
      setTotalStockQuantity([]);
      return;
    }

    // ✅ Extract product IDs, quantities, and stock correctly
    const productIds = row.sales_details.map((item) => item.sales_product_id);
    const quantities = row.sales_details.map((item) => item.sales_quantity);
    const stocks = row.sales_details.map((item) => item.product_quantity);

    console.log("Product IDs:", productIds);
    console.log("Quantities:", quantities);
    console.log("Stocks:", stocks);

    // ✅ Check for out-of-stock products
    const outOfStockIndex = stocks.findIndex((stock) => stock <= 0);
    if (outOfStockIndex !== -1 && row.description === "Paid") {
      setDialogMessage(
        `Products cannot be issued as stock is not available for Product ID ${productIds[outOfStockIndex]}.`
      );
      setDialogType("error");
      setDialogOpen(true);
      return;
    }

    // ✅ Store in state
    setTotalProduct(productIds);
    setTotalQuantity(quantities);
    setTotalStockQuantity(stocks);

    // ✅ Open the dialog
    setDialogOpen(true);
  };

  const updateSaleStatus = async (salesId) => {
    console.log("salesId", salesId);
    try {
      // Use the arrays stored in state
      const productIds = totalProduct; // Should be an array
      const quantities = totalQuantity; // Should be an array
      const stocks = totalStockQuantity; // Should be an array

      console.log("productIds", productIds);

      // Prepare the payload for the API request
      const payload = {
        sales_id: salesId,
        updated_by: userId, // Ensure userId is defined in your scope
        updated_timestamp: new Date(),
        sale_status_id: issuedStatusId, // Set the desired sale status ID
        product_id: productIds, // Use the array of product IDs
        stock: stocks, // Use the array of stocks
        quantity: quantities, // Use the array of quantities
        issue_date: new Date(),
      };

      // Send a single request with the payload
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/updateSaleStatus`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );

      // Check for the response status
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(
          `HTTP error while updating sale status! Status: ${response.status}, Message: ${errorResponse.message}`
        );
      }

      // Parse the response data
      const result = await response.json();
      return result; // Return result for further processing if needed
    } catch (error) {
      console.error("Error updating sale status:", error);
      return null; // Handle the error as necessary
    }
  };

  const handleDialogConfirm = async () => {
    // Call the updateSaleStatus function with the selected salesId
    const result = await updateSaleStatus(selectedSalesId);

    // Check if the update was successful
    if (result) {
      console.log("Sale status updated successfully:", result);
      // You can add additional logic here, such as updating local state or displaying a success message
    } else {
      console.error("Failed to update sale status.");
    }
    // Status just changed — refresh with maintenance so any resulting
    // stale/incomplete rows get cleaned up.
    getSales({ runMaintenance: true });
    setDialogOpen(false); // Close the dialog after confirmation
  };

  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
  };


  // Both search and status are explicit now: typing or picking a status
  // does nothing on its own. Only clicking Go (or pressing Enter in the
  // search box) applies whichever combination is currently set — search
  // alone, status alone, or both together — in a single fetch.
  const handleApplyFilters = () => {
    setDebouncedSearch(search.trim());
    setAppliedStatusId(statusId);
    setPage(0); // Reset to first page since the filtered result set changes
  };

  const handleSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      handleApplyFilters();
    }
  };

  // Clears the search box AND applies that immediately (rather than
  // waiting for Go/Enter) — the whole point of the clear button is to get
  // straight back to the unfiltered-by-search list without an extra click.
  // Status stays as it was; only the search scope resets.
  const handleClearSearch = () => {
    setSearch("");
    setDebouncedSearch("");
    setPage(0);
  };

  useEffect(() => {
    getSales();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [academicYearId, appliedStatusId, page, rowsPerPage, debouncedSearch, orderBy, order]);

  // Tracks state needed to avoid redundant DB round trips per request:
  // - the maintenance pass (cleans up stale sales) only needs to run once
  //   per academic year load, or right after something that could produce
  //   a stale row (a mutation) — not on every page/search/status click.
  // - the total-count query only needs to re-run when the filter/search
  //   scope actually changes, not when merely paging within it.
  // - pageCacheRef holds full page results already fetched this session,
  //   keyed by the exact filter+page combo, so navigating back to a page
  //   already seen (e.g. paging 1→2→back to 1, or re-toggling a status
  //   filter) skips the network entirely. Cleared on any mutation so it
  //   can never serve stale data after a create/edit/refund/status change.
  const hasLoadedOnceRef = React.useRef(false);
  const lastAcademicYearRef = React.useRef(academicYearId);
  const lastCountFilterKeyRef = React.useRef(null);
  const pageCacheRef = React.useRef(new Map());
  const PAGE_CACHE_TTL_MS = 60000; // bounds staleness from other users'/tabs' concurrent changes
  // On a cache miss, fetch this many pages' worth in one request instead of
  // just the one requested — sequential "next page" clicks then land in the
  // same already-fetched block and cost zero additional DB calls. Still
  // bounded (e.g. 3 * 25 = 75 rows max), nowhere near "load everything".
  const PAGE_BLOCK_SIZE = 3;

  const pageCacheKey = (filterKey, pageNum, size) => `${filterKey}|${pageNum}|${size}`;

  // Search refinement cache: when a search (within the current applied
  // status filter) returns its *entire* matching set in one go (total small
  // enough to fit in a single block fetch), it's remembered here. Typing
  // more characters only ever narrows the match (matching "simran" implies
  // matching "sim" implies matching "si" for the same text), so as long as
  // the status filter hasn't changed and the new search term still contains
  // the cached one, we can filter that already-fetched complete set in the
  // browser instead of asking the server again — collapsing "si"→"sim"→
  // "simr"→"simran" (four keystroke pauses, four calls) into a single call.
  // Scoped by statusKey too: without that, caching "ruhaan" under one
  // status and then reusing it after switching to a different status would
  // silently ignore the new status filter (only searches, not statuses,
  // narrow the cached set).
  const fullSearchCacheRef = React.useRef({ statusKey: null, term: null, rows: [] });

  // Mirrors fn_get_sales_by_status_id's search predicate: every word in the
  // term must match SOME field, not necessarily the same one (so "k j"
  // matches first_name "K" + last_name "J"), not the whole phrase as one
  // literal substring against a single field.
  const matchesSalesSearchTerm = (row, term) => {
    const words = term.toLowerCase().trim().split(/\s+/).filter(Boolean);
    const fields = [
      String(row.sales_id ?? "").toLowerCase(),
      (row.first_name || "").toLowerCase(),
      (row.last_name || "").toLowerCase(),
      String(row.contact_no ?? "").toLowerCase(),
    ];
    return words.every((word) => fields.some((field) => field.includes(word)));
  };

  const getSales = async (options = {}) => {
    // On first mount (and briefly after any hard refresh), academicYearId
    // is still "" — Layout resolves it asynchronously and only then sets
    // the real value. Fetching with the empty placeholder would render an
    // empty/wrong result that then gets replaced the moment the real year
    // arrives, which is exactly what shows up as a flicker. Skip the fetch
    // entirely until there's a real year to fetch for.
    if (!academicYearId) {
      return;
    }
    // Also scopes the search-refinement cache below — a different academic
    // year or sort is a different result set entirely, so it can't be
    // reused across years/sorts. academicYearId has to be in here too:
    // switching years doesn't clear debouncedSearch, so without it the
    // refinement shortcut below would see the same search term and status
    // filter, judge the scope "unchanged", and silently serve back the
    // previous year's cached rows for the new year.
    const statusKey = `${academicYearId}|${appliedStatusId}|${orderBy}|${order}`;
    const filterKey = `${statusKey}|${debouncedSearch}`;
    const cacheKey = pageCacheKey(filterKey, page, rowsPerPage);
    const isMutationRefresh = options.runMaintenance === true;

    if (isMutationRefresh) {
      // Data may have changed anywhere — nothing cached can be trusted.
      pageCacheRef.current.clear();
      fullSearchCacheRef.current = { statusKey: null, term: null, rows: [] };
    } else {
      const cached = pageCacheRef.current.get(cacheKey);
      if (cached && Date.now() - cached.timestamp < PAGE_CACHE_TTL_MS) {
        setData(cached.rows);
        setTotalCount(cached.total);
        return; // served from memory — no request made
      }

      // Can this search be answered by narrowing an already-complete set?
      const priorCache = fullSearchCacheRef.current;
      if (
        debouncedSearch &&
        priorCache.statusKey === statusKey &&
        priorCache.term !== null &&
        debouncedSearch.toLowerCase().includes(priorCache.term.toLowerCase())
      ) {
        const filtered = priorCache.rows.filter((row) =>
          matchesSalesSearchTerm(row, debouncedSearch)
        );
        const pageRows = filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        setData(pageRows);
        setTotalCount(filtered.length);
        // The filtered set is itself complete (a subset of a complete set
        // matching a more specific term), so refinement can keep chaining.
        fullSearchCacheRef.current = { statusKey, term: debouncedSearch, rows: filtered };
        lastCountFilterKeyRef.current = filterKey;
        pageCacheRef.current.set(cacheKey, {
          rows: pageRows,
          total: filtered.length,
          timestamp: Date.now(),
        });
        return; // served from memory — no request made
      }
    }

    setLoading(true);
    try {
      const runMaintenance =
        isMutationRefresh ||
        !hasLoadedOnceRef.current ||
        lastAcademicYearRef.current !== academicYearId;
      // If maintenance is running, the underlying data may have changed
      // (deletes/status fixes), so the count needs a fresh look too.
      const skipCount = !runMaintenance && lastCountFilterKeyRef.current === filterKey;

      // Align the fetch to a block boundary and request the whole block.
      const blockIndex = Math.floor(page / PAGE_BLOCK_SIZE);
      const blockStartPage = blockIndex * PAGE_BLOCK_SIZE;
      const blockRowsPerPage = PAGE_BLOCK_SIZE * rowsPerPage;

      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/sales/getSales",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            academic_year_id: academicYearId,
            sales_status_id: appliedStatusId ? appliedStatusId : null,
            page: blockIndex,
            rowsPerPage: blockRowsPerPage,
            search: debouncedSearch || undefined,
            orderBy,
            order,
            runMaintenance,
            skipCount,
          }),
        }
      );
      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();

      if (Array.isArray(responseData?.rows)) {
        // total is null when skipCount was requested — keep the existing
        // totalCount rather than clobbering it with nothing.
        const effectiveTotal =
          responseData.total !== null && responseData.total !== undefined
            ? responseData.total
            : totalCount;
        if (responseData.total !== null && responseData.total !== undefined) {
          setTotalCount(responseData.total);
        }

        // Slice the block into individual pages and cache each one, so the
        // existing per-page lookup above transparently hits these on the
        // next few "next page" clicks.
        for (let i = 0; i < PAGE_BLOCK_SIZE; i++) {
          const subPage = blockStartPage + i;
          const subRows = responseData.rows.slice(i * rowsPerPage, (i + 1) * rowsPerPage);
          pageCacheRef.current.set(pageCacheKey(filterKey, subPage, rowsPerPage), {
            rows: subRows,
            total: effectiveTotal,
            timestamp: Date.now(),
          });
        }

        const requestedPageEntry = pageCacheRef.current.get(cacheKey);
        setData(requestedPageEntry ? requestedPageEntry.rows : []);

        // If this fetch turned out to cover the search's entire matching
        // set (small enough to fit in one block), remember it so further
        // typing can be refined client-side instead of hitting the server.
        // Only touch this when we have a fresh, accurate total (skipCount
        // means we didn't recompute it this round, so leave it as-is).
        if (responseData.total !== null && responseData.total !== undefined) {
          if (debouncedSearch && responseData.total <= blockRowsPerPage) {
            fullSearchCacheRef.current = { statusKey, term: debouncedSearch, rows: responseData.rows };
          } else {
            fullSearchCacheRef.current = { statusKey: null, term: null, rows: [] };
          }
        }
      } else {
        console.error("Unexpected response shape:", responseData);
        setData([]);
        setTotalCount(0);
      }

      hasLoadedOnceRef.current = true;
      lastAcademicYearRef.current = academicYearId;
      if (!skipCount) {
        lastCountFilterKeyRef.current = filterKey;
      }
    } catch (error) {
      console.error("Error fetching fees report:", error);
      setData([]); // Reset to an empty array in case of error
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  // "Download Report" needs every matching sale, not just the current page,
  // so it fetches separately rather than reusing the paginated `data` state.
  const fetchAllSalesForReport = async () => {
    const response = await fetch(
      process.env.REACT_APP_JHS_DEVELOPMENT + "/sales/getSales",
      {
        method: "POST",
        headers: { "Content-type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          academic_year_id: academicYearId,
          sales_status_id: appliedStatusId ? appliedStatusId : null,
          search: debouncedSearch || undefined,
          orderBy,
          order,
          exportAll: true,
        }),
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const responseData = await response.json();
    return Array.isArray(responseData?.rows) ? responseData.rows : [];
  };

  //Arohi
  //Added Sorting and Pagination
  // Sorting now happens server-side, across every matching sale — not just
  // the page on screen. A new sort is effectively a different result
  // order entirely, so this resets to page 0 (staying on "page 3" from the
  // old order wouldn't line up with anything meaningful in the new one).
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setPage(0);
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Search, status filtering, sorting, and pagination all now happen
  // server-side (see getSales) — `data` already holds exactly one correctly
  // ordered page, so no client-side re-sort here. Sorting by an encrypted
  // column (name/contact) costs the same as searching does — the DB has to
  // decrypt the whole matching set before it can order it — but that's the
  // same tradeoff already accepted for search.
  const paginatedRows = data;

  const handleDownload = async () => {
    // The report covers every matching sale, not just the page currently
    // displayed, so it fetches the full (unpaginated) result set on demand.
    let reportRows;
    try {
      reportRows = await fetchAllSalesForReport();
    } catch (error) {
      console.error("Error fetching sales data for report:", error);
      return;
    }

     // Prevent download if rows are empty or all rows contain no meaningful data
     const isDataEmpty = !reportRows || reportRows.length === 0 || reportRows.every((row) => (
      !row.sales_id,
      !row.first_name ,
      !row.last_name,
      !row.father_name ,
      !row.mother_name ,
       !row.guardian_name,
      !row.contact_no,
      !row.sale_date,
      !row.description,
      !row.issue_date,
      !row.description
    ));

    if (isDataEmpty) {
      return;
    }

   const institute = getInstituteConfig(instituteId);

    const doc = new jsPDF();

    // Header background
    doc.setFillColor("#0A64A2");
    const headerHeight = 20;
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

    // Logo
    if (institute.logo) {
      doc.addImage(institute.logo, "PNG", 9, 1, 28, 18);
    }

    // School Name
    const textStartY = 11;
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.text(institute.name, doc.internal.pageSize.getWidth() / 2, textStartY, {
      align: "center",
    });

    // Address
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.text(
      institute.address1,
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 14,
      { align: "center" },
    );
    doc.text(
      institute.address2,
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 18,
      { align: "center" },
    );
    if (institute.tel) {
      doc.text(
        institute.tel,
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 22,
        { align: "center" },
      );
    }

    // Add Receipt Title, Number, and Date - Right aligned
    const receiptTextY = textStartY + 36; // Position the receipt content slightly lower
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(
      "SALES REPORT",
      doc.internal.pageSize.getWidth() / 2,
      receiptTextY,
      { align: "center" }
    ); // Center aligned title
    doc.setFontSize(10);

    //Constants for alignment
    const studentLabelX = 14;
    const grade = `${gradeName || ""}`; // Grade name
    const section = `${sectionName || ""}`; // Section name

    // Constants for alignment and padding
    const pageWidth = doc.internal.pageSize.getWidth(); // Get the width of the PDF page
    const rightPadding = 14; // Padding from the right edge

    // Add Grade, Fees Slab, Pending Fees, and Section dynamically
    const studentDetailsY = receiptTextY + 10;

    // Set font for student name and details
    doc.setFont("helvetica", "bold");
    // --- Add Current Date on the Right Side ---
    // Get the current date
    const today = new Date();
    const currentDate = today.toLocaleDateString("en-GB"); // Format as DD-MM-YYYY

    // Set font for the "Date:" label
    doc.setFont("helvetica", "bold");

    // Get the width of the "Date:" label and the date text
    const dateLabel = "Date: ";
    const dateLabelWidth = doc.getTextWidth(dateLabel);
    const dateWidth = doc.getTextWidth(currentDate);

    // Calculate the X position for the date label (right aligned)
    const dateXPosition = pageWidth - rightPadding - dateWidth - dateLabelWidth; // Position the "Date:" label with padding from the right

    // Add the "Date:" label to the document
    doc.text(dateLabel, dateXPosition, studentDetailsY); // Add the "Date:" label

    // Set font to normal for the actual date
    doc.setFont("helvetica", "normal");
    doc.text(currentDate, dateXPosition + dateLabelWidth, studentDetailsY);

    // Prepare table data
    const tableData = reportRows.map((row) => [
      row.sales_id,
      `${row.first_name} ${row.last_name}`,
      `${row.father_name || row.mother_name || row.guardian_name || ""}`,
      row.contact_no,
      row.sale_date,
      row.description === "Issued" ||
      row.description === "Refunded" ||
      row.description === "Partial Refund"
        ? row.staff_name
        : "", // Include staff_name only if description is "Issued"
      row.issue_date,
      row.description,
    ]);

    // Table settings
    doc.autoTable({
      head: [
        [
          "Indent ID",
          "Student Name",
          "Parent Name",
          "Contact No",
          "Payment Date",
          "Issued By",
          "Issued Date",
          "Status",
        ],
      ],
      body: tableData,
      startY: receiptTextY + 13, // Start table below receipt title
      styles: { fontSize: 8, halign: "center" },
      headStyles: {
        fillColor: "#0A64A2", // Blue header
        textColor: [255, 255, 255], // White text
      },
      theme: "grid",
    });

    // Save the PDF
    doc.save(`sales_report_${new Date().toISOString().slice(0, 10)}.pdf`);
  };

  //download reciept
  const handleDownload1 = async (row, event) => {
    event.stopPropagation();
    const doc = new jsPDF();
 const institute = getInstituteConfig(instituteId);
   
       // Add Logo and Header
       doc.setFillColor("#0A64A2");
       const headerHeight = 20;
       doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");
       doc.setFontSize(14);
       doc.setTextColor(255, 255, 255);
       const textyy = 11;
       doc.setFont("helvetica", "bold");
   
       // School name
       doc.text(
         institute.name,  // ✅ dynamic
         doc.internal.pageSize.getWidth() / 2,
         textyy,
         { align: "center" }
       );
   
       // Logo
       if (institute.logo) {
         doc.addImage(institute.logo, "PNG", 8, 1, 28, 18);  // ✅ dynamic
       }
   
       // Address
       doc.setTextColor(0, 0, 0);
       const textStartY = 15;
       doc.setFontSize(10);
       doc.setFont("helvetica", "normal");
       doc.text(
         institute.address1,  // ✅ dynamic
         doc.internal.pageSize.getWidth() / 2,
         textStartY + 10,
         { align: "center" }
       );
       doc.text(
         institute.address2,  // ✅ dynamic
         doc.internal.pageSize.getWidth() / 2,
         textStartY + 14,
         { align: "center" }
       );
       if (institute.tel) {
         doc.text(
           institute.tel,  // ✅ dynamic, skipped for JPS
           doc.internal.pageSize.getWidth() / 2,
           textStartY + 18,
           { align: "center" }
         );
       }
    // Add Receipt Title, Number, and Date
    const receiptTextY = textStartY + 30;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    if (
      row.description === "Issued" ||
      row.description === "Refunded" ||
      row.description === "Partial Refund"
    ) {
      doc.text(
        "STORE PAYMENT RECEIPT",
        doc.internal.pageSize.getWidth() / 2,
        receiptTextY,
        { align: "center" }
      );
    } else if (row.description === "Paid") {
      doc.text(
        "PROCUREMENT RECEIPT",
        doc.internal.pageSize.getWidth() / 2,
        receiptTextY,
        { align: "center" }
      );
    }
    doc.setFontSize(10);
    const studentDetailsY = receiptTextY + 10;

    // Set font for student name and details
    doc.setFont("helvetica", "bold");
    const studentLabelX = 14;

    // Constants for padding and maximum widths
    const PADDING = 5; // Uniform padding between elements
    const MAX_NAME_WIDTH = 70; // Max width for student name before wrapping

    // Handle long student name
    const studentname = `${row.first_name || ""} ${row.last_name || ""}`.trim(); // Combine first name and last name
    const studentNameWidth = doc.getTextWidth(studentname);
    const splitStudentName =
      studentNameWidth > MAX_NAME_WIDTH
        ? doc.splitTextToSize(studentname, MAX_NAME_WIDTH)
        : studentname;

    doc.text(`Name of Student: `, studentLabelX, studentDetailsY); // Left aligned
    doc.setFont("helvetica", "normal");
    doc.text(splitStudentName, studentLabelX + 30, studentDetailsY); // Adjust X position for student name

    // Dynamically calculate X position for Grade based on student name
    const studentNameActualWidth = Math.min(studentNameWidth, MAX_NAME_WIDTH); // Use actual width or max width
    const gradeX = studentLabelX + 30 + studentNameActualWidth + PADDING;

    // Grade
    doc.setFont("helvetica", "bold");
    doc.text(`Grade:`, gradeX, studentDetailsY);
    const gradeLabelWidth = doc.getTextWidth(`Grade: `);
    doc.setFont("helvetica", "normal");
    const gradeValue = `${row.grade_name || ""}`;
    doc.text(gradeValue, gradeX + gradeLabelWidth, studentDetailsY);

    // Dynamically calculate X position for Section based on Grade
    const gradeValueWidth = doc.getTextWidth(gradeValue);
    const sectionX = gradeX + gradeLabelWidth + gradeValueWidth + PADDING;

    // Section
    doc.setFont("helvetica", "bold");
    doc.text(`Section:`, sectionX, studentDetailsY);
    const sectionLabelWidth = doc.getTextWidth(`Section: `);
    doc.setFont("helvetica", "normal");
    const sectionValue = `${row.section_name || ""}`;
    const sectionValueWidth = doc.getTextWidth(sectionValue);

    // Check if Section exceeds page width and adjust
    if (
      sectionX + sectionLabelWidth + sectionValueWidth >
      doc.internal.pageSize.width
    ) {
      // Move to the next line if it exceeds the page width
      studentDetailsY += 10; // Adjust Y position
      doc.text(`Section:`, studentLabelX, studentDetailsY); // Start from the left
      doc.text(
        sectionValue,
        studentLabelX + sectionLabelWidth,
        studentDetailsY
      );
    } else {
      // Place Section normally
      doc.text(sectionValue, sectionX + sectionLabelWidth, studentDetailsY);
    }

    // Table for Particulars
    const receiptDetails = [
      { title: "Intend ID", value: row.sales_id },
      { title: "Student Name", value: studentname },
      {
        title: "Parent Name",
        value:
          `${row.father_name || ""} ${row.last_name || ""}` ||
          `${row.mother_name || ""} ${row.last_name || ""}` ||
          row.guardian_name,
      },
      { title: "Contact No", value: row.contact_no },
      { title: "Amount Paid", value: row.contact_no }, // This will be updated later
      { title: "Payment Date", value: row.sale_date },
      {
        title: "Issued By",
        value:
          row.description === "Issued" ||
          row.description === "Refunded" ||
          row.description === "Partial Refund"
            ? row.staff_name
            : "",
      },
      { title: "Issue Date", value: row.issue_date },
      { title: "Status", value: row.description },
    ];

    // Initialize product-related values
    let saleProductsValue = "";
    let refundProductsValue = "";
    let totalPrice = 0;

    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/sales/getProduct",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ sales_id: row.sales_id }),
        }
      );

      const productDetails = await response.json();

      if (productDetails.length > 0) {
        totalPrice = productDetails.reduce(
          (sum, product) => sum + (product.price * product.quantity || 0),
          0
        ); // Calculate total price

        productDetails.forEach((product, index) => {
          const productInfo = `${index + 1}. Product: ${
            product.product_name
          }, Quantity: ${product.quantity}, Price: ${product.price}`;

          if (product.type === "sale") {
            saleProductsValue += productInfo + "\n";
          } else if (product.type === "refund") {
            refundProductsValue += productInfo + "\n";
          }
        });
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
    }

    // Update "Amount Paid" field with totalPrice
    receiptDetails.forEach((item) => {
      if (item.title === "Amount Paid") {
        item.value = totalPrice; // Update with calculated total price
      }
    });

    // Add the products based on their type and description
    if (row.description === "Issued") {
      // Show only sale products under "Products Issued"
      receiptDetails.push({
        title: "Products Issued",
        value: saleProductsValue,
      });
    }

    if (row.description === "Refunded") {
      // Show only refund products under "Products Refunded"
      receiptDetails.push({
        title: "Products Refunded",
        value: refundProductsValue,
      });
    }

    if (row.description === "Partial Refund") {
      // Show both "Products Issued" (sale) and "Products Refunded" (refund) separately
      if (saleProductsValue) {
        receiptDetails.push({
          title: "Products Issued",
          value: saleProductsValue,
        });
      }
      if (refundProductsValue) {
        receiptDetails.push({
          title: "Products Refunded",
          value: refundProductsValue,
        });
      }
    }

    if (row.description === "Paid") {
      // Show sale products under "Products To Be Issued"
      receiptDetails.push({
        title: "Products To Be Issued",
        value: saleProductsValue,
      });
    }

    // Table settings
    doc.autoTable({
      head: [["Particulars", "Amount"]],
      // body: receiptDetails.map((item) => [item.title, item.value]),

      body: receiptDetails.map((item) => {
        if (item.title === "Status") {
          return [
            { content: item.title, styles: { fontStyle: "normal" } }, // Bold title
            { content: item.value, styles: { fontStyle: "bold" } }, // Bold value
          ];
        } else {
          return [item.title, item.value]; // Normal styling for other rows
        }
      }),

      startY: receiptTextY + 13, // Start table below student details
      styles: { fontSize: 10, cellPadding: 2 }, // Adjust padding for consistency
      headStyles: {
        fillColor: "#0A64A2", // Blue header
        textColor: [255, 255, 255], // White text
        halign: "left", // Center-align header text
      },
      bodyStyles: {
        halign: "left", // Align text to the left in the body
      },
      columnStyles: {
        0: { cellWidth: 90, halign: "left" }, // Fixed width for the "Particulars" column
        1: { cellWidth: 90, halign: "left" }, // Fixed width for the "Amount" column
      },
      theme: "grid",
    });

    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(
      2,
      "0"
    )}/${String(currentDate.getMonth() + 1).padStart(
      2,
      "0"
    )}/${currentDate.getFullYear()}`;

    // Add the text with the current date
    if (
      row.description === "Issued" ||
      row.description === "Refunded" ||
      row.description === "Partial Refund"
    ) {
      doc.setFont("helvetica", "bold");
      doc.text(`Date: ${formattedDate}`, 14, doc.previousAutoTable.finalY + 40);
      doc.setFont("helvetica", "bold");
      doc.text("Authorized Signatory", 159, doc.previousAutoTable.finalY + 40);
    } else if (row.description === "Paid") {
      doc.setFont("helvetica", "bold");
      doc.text("Accountant Signature", 14, doc.previousAutoTable.finalY + 40);
      doc.setFont("helvetica", "bold");
      doc.text(`Date: ${formattedDate}`, 14, doc.previousAutoTable.finalY + 50);
      doc.setFont("helvetica", "bold");
      doc.text(
        "Store Manager Signature",
        152,
        doc.previousAutoTable.finalY + 40
      );
      doc.setFont("helvetica", "bold");
      doc.text("Date:", 152, doc.previousAutoTable.finalY + 50);
    }

    // Save the PDF
    if (
      row.description === "Issued" ||
      row.description === "Refunded" ||
      row.description === "Partial Refund"
    ) {
      doc.save(
        `store-payment-receipt_${new Date().toISOString().slice(0, 10)}.pdf`
      );
    } else if (row.description === "Paid") {
      doc.save(
        `procurement-receipt_${new Date().toISOString().slice(0, 10)}.pdf`
      );
    }
  };

  const handleStatusChange = (event) => {
    // Just updates what's selected in the dropdown — doesn't apply it.
    // Applying (along with whatever's in the search box) happens on Go.
    const value = event.target.value;
    setStatusName(value);
    if (value === "") {
      // "All" — clears the status filter rather than looking up a real status.
      setStatusId(undefined);
      return;
    }
    let selectedStatus = saleStatus.find(
      (fr) => fr.description === value
    );
    setStatusId(selectedStatus?.sales_status_id);
  };

  return (
    <div style={{ padding: 20 }}>
      <Layout />

      <div>
        <h1 className="sales-title">Sales</h1>
      </div>
      {/* <br /> */}
      <div className="fees_report_box">
        <Stack spacing={4} direction="row">
          <Stack direction="row" alignItems="center">
            {" "}
            {/* Search Box */}
            <Box component="form" className="search-box" style={{ marginRight: "10px" }}>
              <TextField
                label="Search..."
                variant="outlined"
                fullWidth
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                onKeyDown={handleSearchKeyDown}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        type="button"
                        sx={{ p: "10px" }}
                        aria-label="search"
                        onClick={handleApplyFilters}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                  endAdornment: search ? (
                    <InputAdornment position="end">
                      <IconButton
                        type="button"
                        sx={{ p: "6px" }}
                        aria-label="clear search"
                        onClick={handleClearSearch}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
              />
            </Box>
            <Box sx={{ minWidth: 100 }} style={{ marginRight: "10px" }}>
              <FormControl sx={{ minWidth: 100 }} size="small">
                <InputLabel id="demo-simple-select-label" shrink>Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={statusName}
                  label="Grade"
                  onChange={handleStatusChange}
                  displayEmpty
                >
                  <MenuItem value="">All</MenuItem>
                  {saleStatus.map((s) => (
                    <MenuItem key={s.description} value={s.description}>
                      {s.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Button
              onClick={handleApplyFilters}
              style={{
                background: "#0A64A2",
                color: "#fff",
                marginRight: "7px",
                minWidth: "auto",
                paddingTop: "7px",
                paddingBottom: "7px",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              Go
            </Button>
          </Stack>
          <div className="download-report-box-fees-report">
            <Button
              onClick={() => handleOpenComponentCreateSale()}
              style={{
                background: "#0A64A2",
                color: "#fff",
                marginRight: "5px",
              }}
            >
              {" "}
              Create Sale{" "}
            </Button>

            <Button
              className="create-sale-btn"
              // sx={{background:'#0A64A2',padding:"7.5px"}}
              variant="contained"
              onClick={handleDownload}
              startIcon={<DownloadIcon />}
            >
              Download Report
            </Button>
          </div>
        </Stack>
      </div>
      {/* <br /> */}

      <Box className="table-container">
        <Box className="table-container">
          <Paper className="table-container-paper">
            <TableContainer component={Paper} style={{ position: "relative" }}>
              {/* Small, out-of-the-way "still working" cue — rows below
                  stay at full opacity (no dim/blur) the whole time, this is
                  the only loading signal for a refetch (sort, page change,
                  filter). */}
              {loading && paginatedRows.length > 0 && (
                <CircularProgress
                  size={20}
                  style={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
                />
              )}
              <Table
                sx={{ minWidth: 750 }}
                aria-label="custom pagination table"
              >
                <TableHead align="center">
                  <TableRow>
                    <StyledTableCell
                      sortDirection={orderBy === "sales_id" ? order : false}
                      align="center"
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "sales_id"}
                        direction={orderBy === "sales_id" ? order : "asc"}
                        onClick={() => handleRequestSort("sales_id")}
                      >
                        Indent ID
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      sortDirection={orderBy === "first_name" ? order : false}
                      align="center"
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "first_name"}
                        direction={orderBy === "first_name" ? order : "asc"}
                        onClick={() => handleRequestSort("first_name")}
                      >
                        Student Name
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell
                      sortDirection={
                        orderBy === "guardian_name" ? order : false
                      }
                      align="center"
                      // style={{ paddingLeft: "25px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "guardian_name"}
                        direction={orderBy === "guardian_name" ? order : "asc"}
                        onClick={() => handleRequestSort("guardian_name")}
                      >
                        Parent Name
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "34px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "contact_no"}
                        direction={orderBy === "contact_no" ? order : "asc"}
                        onClick={() => handleRequestSort("contact_no")}
                      >
                        Contact No
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "sale_date"}
                        direction={orderBy === "sale_date" ? order : "asc"}
                        onClick={() => handleRequestSort("sale_date")}
                      >
                        Payment Date
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "total_amount_paid"}
                        direction={
                          orderBy === "total_amount_paid" ? order : "asc"
                        }
                        onClick={() => handleRequestSort("total_amount_paid")}
                      >
                        Issued By
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "issue_date"}
                        direction={orderBy === "issue_date" ? order : "asc"}
                        onClick={() => handleRequestSort("issue_date")}
                      >
                        Issue Date
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      <TableSortLabel
                        active={orderBy === "description"}
                        direction={orderBy === "description" ? order : "asc"}
                        onClick={() => handleRequestSort("description")}
                      >
                        Status
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Issued
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Product
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Action
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Return
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Receipt
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                {/* Keep showing the previous page's rows (at full opacity —
                    no dim/blur) while a refetch is in flight, instead of
                    blanking the whole table out to a spinner — that
                    swap-to-blank-and-back is what reads as a flicker on
                    fast requests (cache hits, quick network responses).
                    The small corner spinner above is the only loading cue
                    once there's something on screen; this full-table
                    spinner only shows on a genuine first load. */}
                {(loading || !academicYearId) && paginatedRows.length === 0 ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={12} align="center">
                        <CircularProgress size={24} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {paginatedRows.map((row) => (
                      <StyledTableRow
                        style={{ cursor: "pointer", textAlign: "center" }}
                        key={row.sales_id}
                        tabIndex={-1}
                        padding="none"
                      >
                        <StyledTableCell
                          component="th"
                          scope="row"
                          padding="none"
                          align="center"
                          className="table_content"
                        >
                          {row.sales_id}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.first_name} {row.last_name}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.father_name
                            ? row.father_name
                            : row.mother_name || row.guardian_name}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.contact_no}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.sale_date}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {(row.description === "Issued" ||
                            row.description === "Refunded" ||
                            row.description === "Partial Refund") &&
                            row.staff_name}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.issue_date}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.description}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          style={{ padding: "0" }}
                        >
                          <Checkbox
                            checked={
                              row.description === "Issued" ||
                              row.description === "Refunded" ||
                              row.description === "Partial Refund"
                            }
                            disabled={
                              row.description === "Issued" ||
                              row.description === "Refunded" ||
                              row.description === "Partial Refund"
                            }
                            onChange={() => handleCheckboxClick(row)}
                            style={{marginTop:"5px"}}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          style={{ padding: "0" }}
                        >
                          <ListAltIcon
                            style={{marginLeft: "8px", marginTop:"9px", color: "#0A64A2" }}
                            onClick={() => openList(row.sales_id)} // Pass the sales_id here
                          />
                          {/* Add some margin for spacing */}
                          {/* Product List Dialog */}
                          <Dialog
                            open={open}
                            onClose={handleClose}
                            maxWidth="lg"
                            fullWidth={false}
                            PaperProps={{
                              style: {
                                maxHeight: "90vh",
                                boxShadow: "0",
                              },
                            }}
                            BackdropProps={{
                              style: {
                                backgroundColor: "rgba(0, 0, 0, 0.2)",
                              },
                            }}
                          >
                            <IconButton
                              onClick={handleClose}
                              style={{
                                color: "#817575",
                                position: "absolute",
                                right: "4px",
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                            <Box>
                              <DialogTitle
                                style={{
                                  color: "#0A64A2",
                                  padding: "0px 11px", // Adjust padding for a more compact look
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: "0",
                                  marginTop: "15px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <ListAltIcon
                                    style={{
                                      paddingBottom: "0",
                                      marginTop: "7px",
                                    }}
                                  />
                                  <span
                                    style={{
                                      marginLeft: "8px",
                                      fontWeight: "bold",
                                      fontSize: "18px",
                                      marginTop: "10px",
                                    }}
                                  >
                                    Product List for Indent Id {selectedSalesId}
                                  </span>
                                </div>
                              </DialogTitle>
                            </Box>
                            <Divider
                              className="divider"
                              style={{ width: "94%", marginLeft: "13px" }}
                            />
                            <DialogContent
                              style={{ padding: "0", margin: "0px 10px" }}
                            >
                              {["sale", "refund"].map((type) => {
                                const filteredProducts = product.filter(
                                  (p) =>
                                    p.sales_id === selectedSalesId &&
                                    p.type === type
                                );
                                const totalAmount = filteredProducts.reduce(
                                  (acc, p) => acc + p.total_price,
                                  0
                                );

                                return filteredProducts.length > 0 ? (
                                  <div
                                    key={type}
                                    style={{ marginBottom: "4px" }}
                                  >
                                    {status !== "Paid" &&
                                      status !== "Created" && (
                                        <h4
                                          style={{
                                            color: "#0A64A2",
                                            marginBottom: "0px",
                                            marginTop: "3px",
                                            marginLeft: "2px",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {type === "sale"
                                            ? "Issued Products"
                                            : "Refunded Products"}
                                        </h4>
                                      )}
                                    <Table size="small">
                                      <TableHead>
                                        <TableRow>
                                          <TableCell
                                            style={{
                                              color: "#0A64A2",
                                              padding: "4px",
                                            }}
                                          >
                                            Product Name
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "#0A64A2",
                                              padding: "4px",
                                            }}
                                          >
                                            Attribute
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "#0A64A2",
                                              padding: "4px",
                                            }}
                                          >
                                            Price
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "#0A64A2",
                                              padding: "4px",
                                            }}
                                          >
                                            Quantity
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "#0A64A2",
                                              padding: "4px",
                                            }}
                                          >
                                            Total Price
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {filteredProducts.map((p) => (
                                          <TableRow key={p.product_id}>
                                            <TableCell
                                              align="left"
                                              style={{ padding: "4px" }}
                                            >
                                              {p.product_name}
                                            </TableCell>
                                            <TableCell
                                              align="left"
                                              style={{ padding: "4px" }}
                                            >
                                              {p.attribute_value}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{ padding: "4px" }}
                                            >
                                              {p.price}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{ padding: "4px" }}
                                            >
                                              {p.quantity}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{ padding: "4px" }}
                                            >
                                              {p.total_price}
                                            </TableCell>
                                          </TableRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "end",
                                        marginRight: "10px",
                                        fontWeight: "bold",
                                        fontSize: "0.9rem",
                                        marginTop: "5px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          color:
                                            type === "sale"
                                              ? "#0A64A2"
                                              : "#0A64A2",
                                        }}
                                      >
                                        Total Price:
                                      </span>
                                      &nbsp;
                                      <span
                                        style={{ color: "rgb(58 48 48 / 87%)" }}
                                      >
                                        {totalAmount.toFixed(2)}
                                      </span>
                                    </div>
                                  </div>
                                ) : null;
                              })}

                              {/* Calculate total amounts for both issued and refunded products */}
                              {(() => {
                                const issuedTotal = product
                                  .filter(
                                    (p) =>
                                      p.sales_id === selectedSalesId &&
                                      p.type === "sale"
                                  )
                                  .reduce((acc, p) => acc + p.total_price, 0);

                                const refundTotal = product
                                  .filter(
                                    (p) =>
                                      p.sales_id === selectedSalesId &&
                                      p.type === "refund"
                                  )
                                  .reduce((acc, p) => acc + p.total_price, 0);

                                const grandTotal = issuedTotal + refundTotal;

                                return issuedTotal > 0 && refundTotal > 0 ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "end",
                                      marginRight: "10px",
                                      fontWeight: "bold",
                                      fontSize: "0.9rem",
                                      marginTop: "10px",
                                      borderTop: "1px solid #ddd",
                                      paddingTop: "5px",
                                    }}
                                  >
                                    <span style={{ color: "#0A64A2" }}>
                                      Grand Total:
                                    </span>
                                    &nbsp;
                                    <span
                                      style={{ color: "rgb(58 48 48 / 87%)" }}
                                    >
                                      {grandTotal.toFixed(2)}
                                    </span>
                                  </div>
                                ) : null;
                              })()}

                              {product.filter(
                                (p) => p.sales_id === selectedSalesId
                              ).length === 0 && (
                                <p
                                  style={{
                                    margin: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  No products available.
                                </p>
                              )}
                            </DialogContent>
                          </Dialog>
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          className="table_content"
                          onClick={() => handleOpenComponent(row)}
                          style={{ padding: "0" }}
                        >
                          {row.description === "Created" ? (
                            <Tooltip
                              title="Edit Sale"
                              placement="top"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "white",
                                    color: "rgb(0 0 0 / 90%)",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    boxShadow:
                                      "0px 4px 6px rgba(65, 61, 61, 0.1)",
                                    fontSize: "14px",
                                  },
                                },
                              }}
                            >
                              <img
                                src={editSaleIcon}
                                alt="Edit Sale Icon"
                                style={{ height: "30px", marginBottom: "-2px" }}
                              />
                            </Tooltip>
                          ) : row.description === "Paid" ||
                            row.description === "Issued" ||
                            row.description === "Refunded" ||
                            row.description === "Partial Refund" ? (
                            <Tooltip
                              title="Add Sale"
                              placement="top"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "white",
                                    color: "rgb(0 0 0 / 90%)",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    boxShadow:
                                      "0px 4px 6px rgba(65, 61, 61, 0.1)",
                                    fontSize: "14px",
                                  },
                                },
                              }}
                            >
                              <img
                                src={addSaleIcon}
                                alt="Add Sale Icon"
                                style={{ height: "30px", marginBottom: "-2px" }}
                              />
                            </Tooltip>
                          ) : null}
                        </StyledTableCell>
                        <StyledTableCell align="center" className="table_content" style={{ padding: "0" }}>
        {row.description === "Issued" || row.description === "Partial Refund"? (
          <Tooltip
            title="Return Sale"
            placement="top"
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "white",
                  color: "rgb(0 0 0 / 90%)",
                  padding: "8px",
                  borderRadius: "4px",
                  boxShadow: "0px 4px 6px rgba(65, 61, 61, 0.1)",
                  fontSize: "14px",
                },
              },
            }}
          >
            <img
              src={returnSaleIcon}
              alt="Return Sale Icon"
              style={{
                height: "30px",
                marginBottom: "-2px",
                cursor: "pointer",
              }}
              onClick={()=>handleClick(row)}
            />
          </Tooltip>
        ) : (
          <img
            src={returnSaleIcon}
            alt="Return Sale Icon"
            style={{
              height: "30px",
              marginBottom: "-2px",
              cursor: "pointer",
            }}
            onClick={()=>handleClick(row)}
          />
        )}
      </StyledTableCell>


                        <StyledTableCell align="center" style={{ padding: "0" }}>
                          <Button
                            variant="text"
                            onClick={(event) => handleDownload1(row, event)}
                            startIcon={<DownloadIcon />}
                            style={{ padding: "0" }}
                          />
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                )}
                <TableFooter className="table-footer">
                  <TableRow className="table-header">
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      count={totalCount}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      className="table-pagination"
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Box>
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" },
        }}
      >
        <DialogContent
          style={{
            paddingLeft: dialogType === "confirmation" ? "15px" : "20px",
          }}
        >
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }}
          >
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {dialogType === "confirmation" ? (
            <>
              <Button
                variant="contained"
                onClick={handleDialogConfirm}
                className="no-btn"
              >
                Yes
              </Button>
              <Button
                variant="contained"
                onClick={handleDialogClose}
                autoFocus
                className="no-btn"
              >
                No
              </Button>
            </>
          ) : (
            <Button
              variant="contained"
              onClick={handleDialogClose}
              autoFocus
              className="no-btn"
            >
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Popup Component */}
      <Dialog
        open={openComponent}
        onClose={handleCloseComponent}
        maxWidth="100%"
        fullWidth
      >
        <div className="icon-btn">
          <IconButton
            aria-label="close"
            onClick={handleCloseComponent}
            style={{ color: "rgb(169, 156, 156)", paddingBottom: "0" }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        {selectedData && (
          <div
            className="main_title"
            style={{ paddingLeft: "26px", paddingBottom: "1px" }}
          >
            {selectedData.description === "Created" ? (
              <>
                <img
                  src={editSaleIcon}
                  alt="editSaleIcon"
                  style={{ height: "30px", marginBottom: "-4px" }}
                />
                <span className="create-sale">Edit Sale</span>
              </>
            ) : selectedData.description === "Paid" ||
              selectedData.description === "Issued" ||
              selectedData.description === "Refunded" ||
              selectedData.description === "Partial Refund" ? (
              <>
                <img
                  src={addSaleIcon}
                  alt="addSaleIcon"
                  style={{ height: "30px", marginBottom: "-4px" }}
                />
                <span className="create-sale">Create Sale</span>
              </>
            ) : null}
          </div>
        )}

        <Divider
          className="divider"
          style={{ width: "97%", marginLeft: "25px" }}
        />
        <DialogContent>
          {/* Replace with your CreateSale component */}
          <CreateSale
            studentId1={studentId1}
            studentName={studentName}
            selectedSalesId={selectedSalesId}
            setSelectedSalesId={setSelectedSalesId}
            gradeName={gradeName}
            sectionName={sectionName}
            deleteFlag={deleteFlag}
            deleteData={deleteData}
            setOpenComponent={setOpenComponent}
            setOpenComponentCreateSale={setOpenComponentCreateSale}
            getSales={getSales}
            statusCreatedId={statusCreatedId}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={openComponentCreateSale}
        onClose={handleCloseComponent}
        maxWidth="100%"
        fullWidth
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "8px",
            paddingBottom: "0",
            paddingTop: "0",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseComponent}
            style={{ color: "rgb(169, 156, 156)", paddingBottom: "0" }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div
          className="main_title"
          style={{ paddingLeft: "26px", paddingBottom: "1px" }}
        >
          <img
            src={addSaleIcon}
            alt="addSaleIcon"
            style={{ height: "30px", marginBottom: "-4px" }}
          />
          <span className="create-sale">Create Sale</span>
        </div>

        <Divider
          className="divider"
          style={{ width: "97%", marginLeft: "25px" }}
        />
        <DialogContent>
          {/* Replace with your CreateSale component */}
          <CreateSale
            setOpenComponentCreateSale={setOpenComponentCreateSale}
            setOpenComponent={setOpenComponent}
            getSales={getSales}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={openComponentRefundSale}
        onClose={handleCloseComponent}
        maxWidth="100%"
        fullWidth
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "8px",
            paddingBottom: "0",
            paddingTop: "0",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseComponent}
            style={{ color: "rgb(169, 156, 156)", paddingBottom: "0" }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div
          className="main_title"
          style={{ paddingLeft: "26px", paddingBottom: "1px" }}
        >
          <img
            src={returnSaleIcon}
            alt="returnSaleIcon"
            style={{ height: "30px", marginBottom: "-4px" }}
          />
          <span className="create-sale">Return Sale</span>
        </div>

        <Divider
          className="divider"
          style={{ width: "97%", marginLeft: "25px" }}
        />
        <DialogContent>
          {/* Replace with your CreateSale component */}
          <ReturnSale
            studentId1={studentId1}
            studentName={studentName}
            gradeName={gradeName}
            sectionName={sectionName}
            selectedSalesId={selectedSalesId}
            setOpenComponentRefundSale={setOpenComponentRefundSale}
            getSales={getSales}
          />
        </DialogContent>
      </Dialog>

      
     {/* Dialog Popup */}
     <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" },
        }}
      >
         <DialogContent
          style={{
            paddingLeft: dialogType === "confirmation" ? "15px" : "20px",
          }}
        >
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }}
          >
            {dialogMessageForReturn}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button
              variant="contained"
              onClick={() => setOpenDialog(false)}
              autoFocus
              className="no-btn"
            >
              Ok
            </Button>
         
        </DialogActions>
      </Dialog> 
    </div>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
